import { useLayoutEffect } from 'react';

const useMessageListener = (callback: (...args: any) => void) => {
  useLayoutEffect(() => {
    window.addEventListener('message', callback);
    return () => {
      window.removeEventListener('message', callback);
    };
  }, [callback]);
};

export default useMessageListener;
